<template>
 <div class="container">

<h1><font-awesome-icon icon="home" /> Home - Data - <a href="#">Application</a>
<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>


  <b-modal id="modal-lg" size="lg" title="Data-Application Help">
   
 

  <div class="panal" v-for=" help in info" :key="help.SectionName">
   


    <div  >
      
      <div class="panal-header"> {{ help.SectionName }}</div>
     <div class="panal-body">

     <div v-html="help.SectionDescription"></div>
      </div>
     </div>

  

  </div>
      




  </b-modal>




</div>
</h1>

 

<div class="row">

 <div class="col-md-12" id="tabs">
<div class="tabs">
        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Personal Data</a>
        <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Contact Info</a>
         <a v-on:click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">Education History</a>
          <a v-on:click="activetab=4" v-bind:class="[ activetab === 4 ? 'active' : '' ]">Attachments</a>
           <a v-on:click="activetab=5" v-bind:class="[ activetab === 5 ? 'active' : '' ]">Preferences</a>
            <a v-on:click="activetab=6" v-bind:class="[ activetab === 6 ? 'active' : '' ]">Terms and Conditions</a>
             <a v-on:click="activetab=7" v-bind:class="[ activetab === 7 ? 'active' : '' ]">View Application</a>
    
    </div>

    <div class="content">
        <div v-if="activetab === 1" class="tabcontent">
        <Personal/>
        </div>
        <div v-if="activetab === 2" class="tabcontent">
      <Contact/>
        </div>

          <div v-if="activetab === 3" class="tabcontent">
     <Education/>
        </div>

          <div v-if="activetab === 4" class="tabcontent">
     <Attachments/>
        </div>

          <div v-if="activetab === 5" class="tabcontent">
     <Preferences/>
        </div>

          <div v-if="activetab === 6" class="tabcontent">
     <Terms/>
        </div>

         <div v-if="activetab === 7" class="tabcontent">
    <MyApplication :key="reviewApplication" />
        </div>


      
    </div>




  </div>

















 <!-- <div class="col-md-3 border-right">
    <Tap/>
  </div> -->
  <!-- <div class="col-md-9">
    <div class="tab-content" id="v-pills-tabContent">
      <div class="tab-pane fade show active" id="v-pills-Personal" role="tabpanel" aria-labelledby="v-pills-Personal-tab"><Personal/></div>
      <div class="tab-pane fade" id="v-pills-Contact" role="tabpanel" aria-labelledby="v-pills-Contact-tab"><Contact/></div>
      <div class="tab-pane fade" id="v-pills-Education" role="tabpanel" aria-labelledby="v-pills-Education-tab"><Education/></div>
      <div class="tab-pane fade" id="v-pills-Attachments" role="tabpanel" aria-labelledby="v-pills-Attachments-tab"><Attachments/></div>
      <div class="tab-pane fade" id="v-pills-Preferences" role="tabpanel" aria-labelledby="v-pills-Preferences-tab"> <Preferences/></div>
      <div class="tab-pane fade" id="v-pills-Terms" role="tabpanel" aria-labelledby="v-pills-Terms-tab"> <Terms/></div>
      <div class="tab-pane fade" id="v-pills-MyApplication" role="tabpanel" aria-labelledby="v-pills-MyApplication-tab"> <MyApplication :key="reviewApplication" /></div>
    </div>
  </div>  -->





</div>




</div>

</template>

<script>
// import Tap from "../../components/Applicant/Tap.vue";
import Preferences from "../../components/Applicant/Preferences.vue";
import Personal from "../../components/Applicant/Personal.vue";
import Contact from "../../components/Applicant/Contact.vue";
import Education from "../../components/Applicant/Education.vue";
import Attachments from "../../components/Applicant/Attachments.vue";
import MyApplication from "../../components/Applicant/MyApplication.vue";
import Terms from "../../components/Applicant/Trems.vue";
import ApplicantService from '../../services/Applicant/Applicant.service';
//import ApplicantService from '../services/Applicant/Applicant.service'



export default {
   components: {
     Preferences,Personal,Contact,Education,Attachments,MyApplication,Terms
  
  },
  data () {
    return {
       el: '#tabs',
    activetab: 1,
      info: '',
  
    }
  },

  mounted () {
    let id = 1;

    ApplicantService.GetHelpPages(id).then(response => {
        this.info = response.data.HelpSection
      });


  },
  computed:{
    reviewApplication(){
       return  this.$store.state.auth.renderReview 

        
       }
  }
}


</script>

<style scoped>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#ff8600;
}
.modal-footer {
    background: #f6f6f6 !important;
}

.panal{

  border-radius:10px;
color:#333;
border: 1px solid #d4d4d4;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}




.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}

/* Style the tabs */
.tabs {
    overflow: hidden;
  margin-left: 20px;
    margin-bottom: -2px; 
}

.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a{
    float: left;
    cursor: pointer;
    padding: 12px 10px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #285475;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
     color: #fff;
}
.tabs a:last-child { 
    border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
    background-color: #aaa;
    color: #fff;
}

/* Styling for active tab */
.tabs a.active {
   background-color: #fff;
    color: #285475;
    border-bottom: 2px solid #fff;
    cursor: default;
}

/* Style the tab content */
.tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  background: #fff;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}


</style>
